import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import VotingSessionWidgetController from './controllers/VotingSessionWidgetController';
import styles from './Widget.module.css';
import SlideOutPanel from '../facilitation/VotingSession/SlideOutPanel';
import FistToFiveVoteControl from '../facilitation/VotingSession/FistToFiveVoteControl';

const FistToFiveVotingComponent: React.FC = () => {
  const controller = useController(VotingSessionWidgetController);
  const userId = controller.userId;
  const { widget } = controller.state;
  const [open, setOpen] = React.useState(true);
  if (!widget) return null;

  // Fist to Five votes are global, so they go on the widget object ID
  const vote =
    userId && widget.userHasVotedOnObject(widget.id, userId)
      ? widget.userVotesForObject(widget.id, userId)
      : null;

  return (
    <div className='flex-row px-3 flex-row--align-center'>
      <div className='t-200 color-tertiary pr-1'>
        {vote === null ? (
          'Choose a vote'
        ) : (
          <span className='flex-row flex-row--align-center'>
            You voted
            <span className='pl-2 h-500 font-500 color-primary'>{vote}</span>
          </span>
        )}
      </div>
      <SlideOutPanel direction='horizontal' open={open}>
        <div className={styles.fistToFiveButtons}>
          <FistToFiveVoteControl
            widget={widget}
            value={vote}
            onChange={value => {
              controller.actionSetVotesForObject(widget.id, value);
            }}
          />
        </div>
      </SlideOutPanel>
      <aha-button
        class={styles.sqicon}
        kind='ghost'
        onClick={() => setOpen(!open)}
      >
        <i
          className={`fa-regular fa-chevron-${open ? 'left' : 'right'} mx-auto`}
        />
      </aha-button>
      {!open && <aha-tooltip>Expand and vote</aha-tooltip>}
    </div>
  );
};

export default ApplicationView(FistToFiveVotingComponent);
